import { InputLabel, InputLabelProps } from '@mui/material'
import { CommonLabelProps, StyledTranslationOrText } from '.'

interface LabelProps extends CommonLabelProps {
  inputLabelProps?: Omit<InputLabelProps, 'variant'>
}

export const Label = ({
  inputLabelProps,
  label,
  labelTranslationId
}: LabelProps) => {
  return (
    <InputLabel variant="standard" {...inputLabelProps}>
      <StyledTranslationOrText
        text={label}
        translationId={labelTranslationId}
        typographyProps={{ variant: 'caption' }}
      />
    </InputLabel>
  )
}
